import { useReducer } from "react";
import { GamesData, GamesAction, Games } from "../Games";
import { AllGamesData } from "../GamesDatas";

export const useGamesReducer = () => {
  const [data, dispatch] = useReducer(
    (data: GamesData, action: GamesAction) => {
      console.log(action);
      switch (action.type) {
        case "open":
          return {
            ...data,
            current: AllGamesData.find((game) => game.id === action.id),
            isOpen: true,
            isValid: false,
            progress: 0,
          };
        case "close":
          return { ...data, isOpen: false };
        case "validate":
          return { ...data, isValid: true };
        case "updateProgress":
          return { ...data, progress: action.progress };
        case "unloadGamae":
          return { ...data, current: {} as Games, isValid: false, progress: 0 };
        default:
          return { ...data };
      }
    },
    { current: {} as Games, isOpen: false, isValid: false, progress: 0 }
  );

  return { data, dispatch };
};
